"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderWidget = exports.OpenEndedAt = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Declarative_1 = require("../../utils/Declarative");
// eslint-disable-next-line import/no-cycle
var SliderBaseWidget_1 = require("./SliderBaseWidget");
/**
 * Enumeration of the possible open ended indicators to apply to a SliderWidget. Use this to
 * apply a darkened track bar for the specified open ended at type.
 */
var OpenEndedAt;
(function (OpenEndedAt) {
    /** Use to darken the track bar from [min, value] inclusive */
    OpenEndedAt[OpenEndedAt["Min"] = 0] = "Min";
    /** Use to darken the track bar from [value, max] inclusive */
    OpenEndedAt[OpenEndedAt["Max"] = 1] = "Max";
})(OpenEndedAt = exports.OpenEndedAt || (exports.OpenEndedAt = {}));
/**
 * This slider has one handle and lets a user select a value. It allows the user to choose any number
 * from min to max, including decimal numbers.
 */
function SliderWidget(props) {
    var ariaAttributes = props.ariaAttributes, sliderProps = tslib_1.__rest(props, ["ariaAttributes"]);
    // eslint-disable-next-line max-len
    return React.createElement(SliderBaseWidget_1.SliderBaseWidget, tslib_1.__assign({}, sliderProps, { ariaAttributes: { leftHandle: ariaAttributes, rightHandle: undefined }, testId: Declarative_1.makeTestId(props.testId, 'Slider') }));
}
exports.SliderWidget = SliderWidget;
//# sourceMappingURL=SliderWidget.js.map